// LiveStreamBadge.js
import { connect } from 'react-redux';

import LiveStreamBadge from '../component/LiveStreamBadge.jsx';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getLivestreamComputedMode from '../selector/getLivestreamComputedMode.js';

const mapStateToProps = (state, { streamId }) => {
  return {
    mode: getLivestreamComputedMode(state, streamId),
    // The mode only says a 1-1 is running; the badge also needs to tell the
    // lead-in from the performance itself.
    exclusivePrivateStatus: getLiveStreamData(
      state,
      [streamId, 'exclusivePrivate'],
      'status'
    ),
  };
};

export default connect(
  mapStateToProps,
  null,
  // equals to `{ ...ownProps, ...stateProps, ...dispatchProps }`
  // ref: https://github.com/reduxjs/react-redux/blob/v7.1.0/src/connect/mergeProps.js
  null,
  { forwardRef: true } // Required by WithIntersectionObserver
)(LiveStreamBadge);
